import jwtDecode, { JwtPayload } from 'jwt-decode';
import { IUserDetails } from 'src/interfaces/user';

/**
 * UNVERIFIED — DISPLAY ONLY.
 *
 * This decodes the JWT payload WITHOUT checking signature or expiry.
 * Do NOT use the result for any authorization or identity decision —
 * who is logged in, what they're allowed to do, or whose record to
 * mutate. Use `getVerifiedUserDetails` / `verifyAccessToken`
 * (src/utilities/auth/) for anything security-relevant.
 *
 * Safe remaining uses: cosmetic client-side display (e.g. showing a
 * first name) where a forged token has no security impact.
 */
const decodeAccessToken = (accessToken?: string): IUserDetails | undefined => {
  if (!accessToken || accessToken === '') {
    return undefined;
  }

  const decodedAccessToken = jwtDecode<JwtPayload>(accessToken);

  const {
    email: userEmail,
    roles,
    firstName,
    lastName,
    orchaUserId,
    marketingOptIn,
    isExternal,
    externalSource,
  } = (decodedAccessToken as any) ?? {};

  return {
    firstName,
    lastName,
    email: userEmail,
    roles,
    userId: orchaUserId,
    marketingOptIn,
    isExternal: isExternal ?? false,
    externalSource: externalSource ?? null,
  };
};

export default decodeAccessToken;
